import React, { useState } from "react";
import styles from "./Contact.module.css";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [contact, setContact] = useState<string>("");
  const [name, setName] = useState<string>("");

  const sendMail = () => {
    if (
      email.trim() === "" ||
      name.trim() === "" ||
      message.trim() === "" ||
      contact.trim() === ""
    ) {
      alert("Please fill all the details");
      return;
    }
    const templateParams = {
      reply_to: email,
      to_name: "Anton",
      from_name: name,
      message: message,
      contact,
    };
    emailjs
      .send(
        "service_8013cq8",
        "template_ggixj8m",
        templateParams,
        "gcVkZvmB8Tx6pEQJF"
      )
      .then(
        (response) => {
          alert("Message send successfully");
        },
        (err) => {
          console.log("FAILED...", err);
        }
      );
    setName("");
    setEmail("");
    setContact("");
    setMessage("");
  };
  return (
    <section id="contact" className={styles.container}>
      <div className={styles.left}>
        <h1>Contact Me</h1>
        <p>
          You can write a mail directly to me if you want to work with me or
          collaborate for a project.
        </p>
      </div>
      <div className={styles.right}>
        <label>Name</label>
        <br />
        <input
          type="text"
          placeholder="Your name"
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
        <br />
        <label>Email</label>
        <br />
        <input
          type="email"
          placeholder="Your contact email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />
        <br />
        <label>Contact No</label>
        <br />
        <input
          type="number"
          placeholder="Your contact number"
          onChange={(e) => setContact(e.target.value)}
          value={contact}
        />
        <br />
        <label>Message</label>
        <br />
        <textarea
          rows={3}
          placeholder="Write your message"
          onChange={(e) => setMessage(e.target.value)}
          value={message}
        />
        <br />
        <button onClick={sendMail}>Send Message</button>
      </div>
    </section>
  );
};

export default Contact;
